
import { Window_OverlayReward } from './Window_overlayReward';

class Window_TreasureHuntMainReward extends Window_OverlayReward {
  /**
   * constructor
   * @param {Object} parent
   * @param {Object} config
   */
  constructor(parent, config) {
    super(parent);

    if (DDNA.tracking.enabled) DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('seenTreasureHuntShareBtn', 1);

    // overlay reward config
    const treasureHuntRewardConfig = G.TreasureHunt.treasureHuntMgr.getMainReward();
    const endMsg = OMT.language.getText('You got unlimited lives for 15 minutes!')
      .replace('15', G.OMTsettings.unlimitedLivesMinDefaultReward);
    const rewardConfig = {
      unlimitedLivesMin: G.OMTsettings.unlimitedLivesMinDefaultReward,
      gifts: treasureHuntRewardConfig.gifts,
      endMsg,
      showShare: false,
      shareFunction: (callback) => {
        OMT.social.shareTreasureHuntCompleteMsg(() => {
          DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('usedTreasureHuntShareBtn', 1);
          if (callback) callback();
        });
      },
      tweensSettings: [
        { x: 10, y: -266, angle: -3 },
        { x: 133, y: -499, angle: 15 },
        { x: -133, y: -425, angle: -10 },
      ],
      onClaimCallback: config.onClaimCallback,
      ddnaEventData: { transactionType: 'REWARD', tActionType: 'TREASURE_HUNT', tGameArea: game.state.getCurrentState().key === 'Game' ? 'LEVEL' : 'MAP' },
    };

    this._initProgressionPanel(rewardConfig);

    G.sb('hideMainHighscorePanel').dispatch();
  }

  /**
   * init the tresure hunt progression panel
   * @param {Object} rewardConfig
   */
  _initProgressionPanel(rewardConfig) {
    const { treasureHuntMgr } = G.TreasureHunt;
    const { TreasureHuntProgressionPanel } = G.TreasureHunt;
    const progressData = treasureHuntMgr.getProgressData();

    const progressionPanel = this.add(new TreasureHuntProgressionPanel({
      tutorial: false,
      value: 0,
      valueTarget: progressData.gemsTarget,
      target: progressData.gemsTarget,
      sounds: {
        onIncrease: G.sfx.pop,
        onComplete: G.sfx.match_5,
      },
    }));

    game.add.tween(progressionPanel.scale)
      .from({ x: 0, y: 0 }, 1000, Phaser.Easing.Sinusoidal.Out, true)
      .onComplete.add(() => {
        progressionPanel.showProgress();
      });

    progressionPanel.onShowProgressFinish.add(() => {
      game.add.tween(progressionPanel)
        .to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true)
        .onComplete.add(() => {
          this.overlayReward(rewardConfig);
          game.add.tween(this)
            .from({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true);
        }, this);
    }, this);
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.treasureHuntMainReward = Window_TreasureHuntMainReward;
